import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { AttributeType, gl } from '@antv/l7-core';
import { lodashUtil } from '@antv/l7-utils';
import BaseModel from "../../core/BaseModel";
import { earthOuterTriangulation } from "../../core/triangulation";
/* babel-plugin-inline-import '../shaders/bloomshpere/bloomsphere_frag.glsl' */
const bloomSphereFrag = "\nin vec3 vVertexNormal;\nin vec4 v_Color;\n\nlayout(std140) uniform commonUniforms {\n float u_opacity;\n};\nout vec4 outputColor;\n#pragma include \"scene_uniforms\"\nvoid main() {\n    float intensity =  - dot(normalize(vVertexNormal), normalize(u_CameraPosition));\n    // \u53BB\u9664\u80CC\u9762\n    if(intensity > 1.0) intensity = 0.0;\n\n    outputColor = vec4(v_Color.rgb, v_Color.a * intensity * u_opacity);\n}\n";
/* babel-plugin-inline-import '../shaders/bloomshpere/bloomsphere_vert.glsl' */
const bloomSphereVert = "layout(location = ATTRIBUTE_LOCATION_POSITION) in vec3 a_Position;\nlayout(location = ATTRIBUTE_LOCATION_COLOR) vec4 a_Color;\nlayout(location = ATTRIBUTE_LOCATION_NORMAL) in vec3 a_Normal;\nlayout(location = ATTRIBUTE_LOCATION_UV) in vec2 a_Uv;\n\nlayout(std140) uniform commonUniforms {\n float u_opacity;\n};\n#pragma include \"scene_uniforms\"\n\nout vec3 vVertexNormal;\nout vec4 v_Color;\n\nvoid main() {\n    v_Color = a_Color;\n\n    vVertexNormal = a_Normal;\n\n    gl_Position = u_ViewProjectionMatrix * u_ModelMatrix * vec4(a_Position, 1.0);\n}\n";
const {
  isNumber
} = lodashUtil;
export default class EarthBloomSphereModel extends BaseModel {
  get attributeLocation() {
    return Object.assign(super.attributeLocation, {
      MAX: super.attributeLocation.MAX,
      NORMAL: 9,
      UV: 10
    });
  }
  getCommonUniformsInfo() {
    const {
      opacity = 1
    } = this.layer.getLayerConfig();
    const commonOptions = {
      u_opacity: isNumber(opacity) ? opacity : 1.0
    };
    const commonBufferInfo = this.getUniformsBufferInfo(commonOptions);
    return commonBufferInfo;
  }
  initModels() {
    var _this = this;
    return _asyncToGenerator(function* () {
      _this.initUniformsBuffer();
      return _this.buildModels();
    })();
  }
  clearModels() {
    return '';
  }
  buildModels() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      // Tip: 调整图层的绘制顺序，让它保持在地球后面（减少锯齿现象）
      _this2.layer.zIndex = -999;
      const model = yield _this2.layer.buildLayerModel({
        moduleName: 'earthBloom',
        vertexShader: bloomSphereVert,
        fragmentShader: bloomSphereFrag,
        defines: _this2.getDefines(),
        triangulation: earthOuterTriangulation,
        depth: {
          enable: false
        },
        blend: _this2.getBlend()
      });
      return [model];
    })();
  }
  registerBuiltinAttributes() {
    // this.styleAttributeService.registerStyleAttribute({
    //   name: 'size',
    //   type: AttributeType.Attribute,
    //   descriptor: {
    //     name: 'a_Size',
    //     shaderLocation: this.attributeLocation.SIZE,
    //     buffer: {
    //       usage: gl.DYNAMIC_DRAW,
    //       data: [],
    //       type: gl.FLOAT,
    //     },
    //     size: 1,
    //     update: (feature: IEncodeFeature) => {
    //       const { size = 1 } = feature;
    //       return Array.isArray(size) ? [size[0]] : [size as number];
    //     },
    //   },
    // });

    this.styleAttributeService.registerStyleAttribute({
      name: 'normal',
      type: AttributeType.Attribute,
      descriptor: {
        name: 'a_Normal',
        shaderLocation: this.attributeLocation.NORMAL,
        buffer: {
          usage: gl.STATIC_DRAW,
          data: [],
          type: gl.FLOAT
        },
        size: 3,
        update: (feature, featureIdx, vertex, attributeIdx, normal) => {
          return normal;
        }
      }
    });
    this.styleAttributeService.registerStyleAttribute({
      name: 'uv',
      type: AttributeType.Attribute,
      descriptor: {
        name: 'a_Uv',
        shaderLocation: this.attributeLocation.UV,
        buffer: {
          usage: gl.DYNAMIC_DRAW,
          data: [],
          type: gl.FLOAT
        },
        size: 2,
        update: (feature, featureIdx, vertex) => {
          return [vertex[3], vertex[4]];
        }
      }
    });
  }
}